import React from 'react'
import GalleryVideos from '../components/GalleryVideos'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ProductsBanner from '../components/ProductsBanner'


const Gallery = () => {
  return (
    <div>
        <Header/>
        <ProductsBanner
        title="Gallery"
        backgroundImage="https://skyhitmedia.in/media/drchek.jpg"
        backgrond="cover"
        height="400px"
      />
     
        <GalleryVideos/>
        <Footer/>
    </div>
  )
}

export default Gallery